import React from "react";
import { Route, Routes as ReactRoutes } from "react-router-dom";
import useFetchMenu from "Common/FetchAllMenu";
import { CanAccessThisPage } from "Common/RoleVerify";

import RoomFacilitiesDetailList from "Partials/Universal/Hotels/Room Facilites/RoomFacilityDetail/RoomFacilitesDetailList/RoomFacilitiesDetailList";
import PromoCodeList from "Partials/RoomsSettings/PromoCode/PromoCodeList/PromoCodeList";
import BookingList from "Partials/Universal/RoomBook/Booking/BookingList/BookingList";
import RoomStatus from "Partials/Universal/RoomBook/RoomStatus/RoomStatus";
import BookingTypeList from "Partials/RoomsSettings/BookingTypeList/BookingTypeList";
import ComplementaryList from "Partials/RoomsSettings/ComplementaryList/ComplementaryListing/ComplementaryList";
import FloorPlanList from "Partials/RoomsSettings/FloorAssign/FloorAssignList/FloorPlanList";
import RoomList from "Partials/RoomsSettings/RoomList/RoomList/RoomList";
import FloorList from "Partials/RoomsSettings/Floor/FloorList/FloorList";
import RoomImages from "Partials/RoomsSettings/RoomImages/RoomImagesList/RoomImages";
import CustomerList from "Partials/Universal/Hotels/Customers/Customer/CustomersList/Customers";
import GuestList from "Partials/Universal/Hotels/Customers/guest/GuestList/GuestList";
import BedList from "Partials/RoomsSettings/BedList/BadlList/BedList";
import RoomFacilitiesList from "Partials/Universal/Hotels/Room Facilites/RoomFacilityType/RoomFacilitesList/RoomFacilitiesList";
import RoomSizeList from "Partials/Universal/Hotels/Room Facilites/RoomSize/RoomSizeList/RoomSizeList";
import ProductCategoryList from "Partials/Universal/ItemsManage/CategoryList/CategoryList/CategoryList";
import ProductList from "Partials/Universal/ItemsManage/Product/ProductList/ProductList";
import DestroyedList from "Partials/Universal/ItemsManage/DestroyedList/DestroyedList/DestroyedList";
import SupplierList from "Partials/Universal/ItemsManage/Supplier/SupplierList/SupplierList";
import ItemsUnitList from "Partials/Universal/ItemsManage/ItemsUnit/ItemsUnitList/ItemsUnitList";
import TexManagementList from "Partials/Universal/Hotels/TaxManagement/TaxList/TaxList";
import WakeUpCallList from "Partials/Universal/Hotels/Customers/WakeUpCall/WakeUpCallList/WakeUpCallList";
import PaymentCurrencyList from "Partials/Universal/Hotels/PaymentSetting/CurrencyList/CurrencyList/CurrencyList";
import PurchaseItemList from "Partials/Universal/Hotels/PurchaseManagement/PurchaseItem/PurchaseItemList/PurchaseItemList";
import ReturnInvoiceList from "Partials/Universal/Hotels/PurchaseManagement/ReturnInvoice/ReturnInvoiceList/ReturnInvoiceList";
import PoolTypeList from "Partials/Universal/Hotels/PoolBooking/PoolType/PoolTypeList/PoolTypeList";
import RoomCheckInList from "Partials/Universal/RoomBook/RoomCheckIn/RoomCheckInList/RoomCheckInList";
import BookingCommissionList from "Partials/RoomsSettings/BookingCommission/BookingCommissionList/BookingCommissionList";
import PaymentSetupList from "Partials/Universal/Hotels/PaymentSetting/PaymentSetup/PaymentSetupList/PaymentSetupList";
import PaymentMethodList from "Partials/Universal/Hotels/PaymentSetting/PaymentMethod/PaymentMethodList/PaymentMethodList";
import PoolPackageList from "Partials/Universal/Hotels/PoolBooking/PoolPackage/PoolPackageList/PoolPackageList";
import SwimmingPoolList from "Partials/Universal/Hotels/PoolBooking/SwimmingPool/SwimmingPoolList/SwimmingPoolList";
import SlotList from "Partials/Universal/Hotels/CarParking/SlotList/SlotList/SlotList";
import PoolBookingList from "Partials/Universal/Hotels/PoolBooking/PoolBooking/PoolBookingList/PoolBookingList";
import ZoneTypeList from "Partials/Universal/Hotels/CarParking/ZoneType/ZoneTypeList/ZoneTypeList";
import VehicleList from "Partials/Universal/Hotels/CarParking/VehicleList/VehicleList/VehicleList";
import SettingList from "Partials/Universal/Hotels/CarParking/SettingList/SettingList/SettingList";
import HallSeatPlanList from "Partials/Universal/Hotels/EventBooking/HallSeatPlan/HallSeatPlanList/HallSeatPlanList";
import HallRoomTypeList from "Partials/Universal/Hotels/EventBooking/HallRoomType/HallRoomTypeList/HallRoomTypeList";
import FoodTypeList from "Partials/Universal/Hotels/FoodBooking/FoodType/FoodTypeList/FoodTypeList";
import FoodList from "Partials/Universal/Hotels/FoodBooking/FoodList/FoodList/FoodList";
import FoodpackageList from "Partials/Universal/Hotels/FoodBooking/Foodpackage/FoodpackageList/FoodpackageList";
import PFTLList from "Partials/Universal/Hotels/FoodBooking/PackageFoodTypeLimit/PFTLList/PFTLList";
import LaundryProductList from "Partials/Universal/Hotels/Laundry/LaundryProduct/LaundryProductList/LaundryProductList";
import LaundryTaskList from "Partials/Universal/Hotels/Laundry/LaundryTask/LaundryTaskList/LaundryTaskList";
import LaundryList from "Partials/Universal/Hotels/Laundry/Laundry/LaundryList/LaundryList";
import LaundryItemCostList from "Partials/Universal/Hotels/Laundry/LaundryItemCost/LaundryItemCostList/LaundryItemCostList";
import PurchaseReturnList from "Partials/Universal/Hotels/PurchaseManagement/PurchaseReturn/PurchaseReturnList"
import HousekeepingList from "Partials/Universal/Hotels/Housekeeping/Housekeeping/HousekeepingList/HousekeepingList"
import CategoryList from "Partials/Universal/ItemsManage/CategoryList/CategoryList/CategoryList"

import FlightList from "Partials/Universal/Hotels/TransportFacility/FlightDetails/FlightList/FlightList";
import VehicleDetailsList from "Partials/Universal/Hotels/TransportFacility/VehicleDetails/VehicleList/VehicleList";
import VehicleBookingList from "Partials/Universal/Hotels/TransportFacility/VehicleBooking/VehicleBookingList/VehicleBookingList";
import EmployeeAssignList from "Partials/Universal/Hotels/DutyRoster/AssignedEmployee/AssignedEmployeeList/EmployeeAssignList";
import ShiftList from "Partials/Universal/Hotels/DutyRoster/ShiftList/ShiftList";
import AttendanceDashboard from "Partials/Universal/Hotels/DutyRoster/AttendanceDashboard/AttendanceDashboard";
import RosterList from "Partials/Universal/Hotels/DutyRoster/DutyRoster/RostersList/Rosters";
import HallBookingList from "Partials/Universal/Hotels/EventBooking/HallBooking/HallBookingList/HallBookingList";
import RosterAssignList from "Partials/Universal/Hotels/DutyRoster/AssignedRoster/RosterAssignedList/RosterAssignedList"
import ParkingBookingList from "Partials/Universal/Hotels/CarParking/CarBooking/ParkingBookingList/ParkingBookingList";
import HallImagesList from "Partials/Universal/Hotels/EventBooking/HallImages/HallImagesList/HallImages";
import PaymentTransactionList from "Partials/Universal/Hotels/PaymentSetting/PaymentTransaction/PaymentTransactionList/PaymentTransactionList";
import BookingReport from "Partials/Universal/RoomBook/BookingCheckOutReport/BookingReport"
import DailyBusinessReport from "Partials/Universal/RoomBook/BookingCheckOutReport/DailyBusinessReport"
import MonthlyStatistics from "Partials/Universal/RoomBook/MonthlyStatistics/MonthlyStatistics"
import CustomerRefundList from "Partials/Universal/Hotels/Customers/Customer/CustomerRefund/CustomerRefundList"
import RefundHistoryList from "Partials/Universal/Hotels/Customers/Customer/CustomerRefundHistory/RefundHistoryList"
import BookingPaymentHistoryList from "Partials/Universal/Hotels/Customers/Customer/BookingPaymentHistory/BookingPaymentHistoryList"
import RoomCheckOut from "Partials/Universal/RoomBook/RoomCheckOut/RoomCheckOut";
import RoomNoFloorAssignList from "Partials/RoomsSettings/RoomStatus/RoomNoFloorAssignList/RoomNoFloorAssignList"

const hotelComponents = {
  FloorList,
  FloorPlanList,
  ComplementaryList,
  RoomList,
  SettingList,
  ParkingBookingList,
  FoodTypeList,
  PFTLList,
  LaundryProductList,
  LaundryTaskList,
  LaundryItemCostList,
  LaundryList,
  ReturnInvoiceList,
  PurchaseItemList,
  PaymentSetupList,
  PaymentMethodList,
  BookingCommissionList,
  PaymentCurrencyList,
  WakeUpCallList,
  TexManagementList,
  ItemsUnitList,
  DestroyedList,
  SupplierList,
  ProductCategoryList,
  RoomSizeList,
  ProductList,
  RoomFacilitiesList,
  BedList,
  RoomImages,
  HallImagesList,
  GuestList,
  CustomerList,
  RoomCheckInList,
  PoolTypeList,
  SwimmingPoolList,
  PoolPackageList,
  PoolBookingList,
  ZoneTypeList,
  SlotList,
  RoomFacilitiesDetailList,
  PromoCodeList,
  BookingList,
  RoomStatus,
  BookingTypeList,
  FoodpackageList,
  VehicleList,
  FoodList,
  HallRoomTypeList,
  HallSeatPlanList,
  PurchaseReturnList,
  HousekeepingList,
  FlightList,
  VehicleDetailsList,
  VehicleBookingList,
  CategoryList,
  ShiftList,
  EmployeeAssignList,
  RosterList,
  AttendanceDashboard,
  HallBookingList,
  RosterAssignList,
  PaymentTransactionList,
  BookingReport,
  DailyBusinessReport,
  MonthlyStatistics,
  CustomerRefundList,
  RefundHistoryList,
  BookingPaymentHistoryList,
  RoomCheckOut,
  RoomNoFloorAssignList
};

const HotelDynamicRoutes = () => {
  const { menu: hotelMenu } = useFetchMenu("hotel");

  const SpretMenu = hotelMenu ? hotelMenu.flatMap((item) => item.children || []) : [];

  return SpretMenu.map((item, index) => {
    const Component = hotelComponents[item.component_name];
    if (!Component) {
      return null;
    }
    return (
      <Route
        key={index}
        path={`/${item.page_url}`}
        element={
          <CanAccessThisPage menu_access={['can_access', 'can_create', 'can_edit', 'can_delete']} page_url={item?.page_url}>
            {<Component />}
          </CanAccessThisPage>
        }
      />
    );
  }).filter(Boolean);
};

export default HotelDynamicRoutes;